// Draft package features. Edit freely; no prices are shown anywhere on the site.
export const PACKAGES = [
  {
    id: "starter",
    name: "Starter",
    quoteTopic: "Starter website package",
    blurb: "A clean, fast one-page site that gets you found and makes it easy to call.",
    features: [
      "One-page website",
      "Designed for phones first",
      "Tap-to-call button and contact form",
      "Hours, map, and service area",
      "Basic Google search setup",
      "Launch support",
    ],
  },
  {
    id: "standard",
    name: "Standard",
    popular: true,
    quoteTopic: "Standard website package",
    blurb: "A full multi-page website for businesses ready to look established online.",
    features: [
      "Up to 5 pages",
      "Custom design based on your free mockup",
      "Contact and quote request forms",
      "Help setting up your Google Business Profile",
      "Search-friendly page titles and descriptions",
      "Live in 7–10 days",
    ],
  },
  {
    id: "growth",
    name: "Growth",
    quoteTopic: "Growth website package",
    blurb: "For busy businesses that want more booked jobs and less back-and-forth.",
    features: [
      "Everything in Standard",
      "Up to 10 pages",
      "Pages for each service and town you serve",
      "One automation add-on included",
      "Photo gallery or project showcase",
      "Priority launch support",
    ],
  },
];

export const CARE_PLANS = [
  {
    id: "essential",
    name: "Essential",
    quoteTopic: "Essential care plan",
    blurb: "Keep your site safe, backed up, and running smoothly.",
    features: [
      "Secure hosting and SSL",
      "Software and security updates",
      "Regular backups",
      "Small text and photo edits",
      "Email support",
    ],
  },
  {
    id: "full",
    name: "Full",
    quoteTopic: "Full care plan",
    blurb: "Hands-off care, with updates and changes handled for you.",
    features: [
      "Everything in Essential",
      "More edits each month",
      "Seasonal updates to hours, offers, and photos",
      "Google Business Profile updates",
      "Monthly check-in",
      "Priority support",
    ],
  },
];

export const ADDONS = [
  {
    id: "missed-call",
    name: "Missed-call text-back",
    icon: "PhoneMissed",
    quoteTopic: "Missed-call text-back add-on",
    blurb: "Miss a call and the caller gets a friendly text right away, so the job doesn't go to the next name on Google.",
    features: ["Automatic text after a missed call", "Your wording and business name", "Replies come straight to your phone"],
  },
  {
    id: "reviews",
    name: "Review requests",
    icon: "Star",
    quoteTopic: "Review requests add-on",
    blurb: "After a job, customers get a quick text or email asking them to leave a Google review.",
    features: ["Sends after each completed job", "One-tap link to your Google review page", "A simple, polite reminder"],
  },
  {
    id: "booking",
    name: "Online booking",
    icon: "CalendarCheck",
    quoteTopic: "Online booking add-on",
    blurb: "Let customers pick a time on your website instead of playing phone tag.",
    features: ["Booking right on your website", "Works with your calendar", "Confirmation and reminder messages"],
  },
];
